import React, { useState } from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'
import { DashboardCardWrapper } from '../../commonComponents/DashboardCardWrapper'

const paymentMethods = [
    {
        name: 'UPI',
        value: 45,
        color: '#6366F1'
    },
    {
        name: 'Cheque',
        value: 15,
        color: '#10B981'
    },
    {
        name: 'Bank Transfer',
        value: 25,
        color: '#F59E0B'
    },
    {
        name: 'Credit Card',
        value: 15,
        color: '#EC4899'
    }
]

export const PaymentMethodsChart = () => {
    const [activeMethod, setActiveMethod] = useState(paymentMethods[2])
    return (
        <DashboardCardWrapper headerText={"Payment Methods"} componentStyles={{ width: "35%" }}>
            <div
                className="d-flex flex-column align-items-center justify-content-center gap-2"
                style={{ position: 'relative', height: '100%', width: '100%', marginTop: "-1.8rem" }}
            >
                <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                        <Pie
                            data={paymentMethods}
                            cx="50%"
                            cy="50%"
                            innerRadius={80}
                            outerRadius={102}
                            dataKey="value"
                            cornerRadius={0}
                            paddingAngle={2}
                            onMouseEnter={(_, index) => setActiveMethod(paymentMethods[index])}
                        >
                            {paymentMethods !== null &&
                                paymentMethods?.map((entry, idx) => (
                                    <Cell key={idx} fill={entry.color} />
                                ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div
                    style={{
                        position: 'absolute',
                        top: '45%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                        pointerEvents: 'none'
                    }}
                >
                    <span className='d-block fs-12 text-muted'>
                        {activeMethod?.name}
                    </span>
                    <span
                        className='d-block'
                        style={{
                            fontSize: '24px',
                            fontWeight: 700,
                            color: activeMethod?.color
                        }}
                    >
                        {activeMethod?.value}%
                    </span>
                </div>
                <div className='row g-3 mx-auto' style={{ maxWidth: '400px' }}>
                    {paymentMethods.map((method) => (
                        <div
                            key={method.name}
                            className='col-6 d-flex align-items-center gap-2'
                        >
                            <span
                                style={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    background: method.color,
                                    display: 'inline-block',
                                    flexShrink: 0
                                }}
                            />
                            <span className='fs-12 text-nowrap'>
                                {method.name} ({method.value}%)
                            </span>
                        </div>
                    ))}
                </div>

            </div>
        </DashboardCardWrapper>
    )
}